module.exports = __webpack_public_path__ + "img/loe_Kurt_blir_grusom1.3504be4f.jpg";